import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Element } from '../../../common/html/element'
import { ScrollComponent } from '../../../common/scrollComponent'
import { Footer } from '../../../layout/footer'
import classes from './index.module.scss'
import './lang/i18n'
import { SearchFilter } from './searchFilter'
import { SearchResults } from './searchResults'
import { changeTextSearch, reset, selectTextSearch } from './store/slice'
import { getCategoryLegalFormAdjusted, getCompanyStatus } from './store/thunk'

const DomesticSearch = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const text = params.get('text') || ''

  // Use selector
  const locale = useSelector((state) => state.i18n.locale)
  const textSearch = useSelector(selectTextSearch)

  // Use effect
  useEffect(() => {
    dispatch(changeTextSearch(text))
    return () => dispatch(reset())
  }, [])

  useEffect(() => {
    dispatch(getCategoryLegalFormAdjusted())
    dispatch(getCompanyStatus())
  }, [locale])

  return (
    <div
      className={['w100 h100 dFlex', classes.domesticSearchContainer].join(' ')}
    >
      <Element
        elementName="div"
        className={classes.searchFilter}
        style={{
          backgroundColor: '#e5e5e5',
        }}
      >
        <SearchFilter textSearch={textSearch} />
      </Element>
      <Element
        elementName="div"
        className={['w100', classes.contentRight].join(' ')}
        style={{ backgroundColor: '#fff' }}
      >
        <ScrollComponent>
          <div className={classes.searchResultsContainer}>
            <SearchResults textSearch={textSearch} />
          </div>
          <Footer />
        </ScrollComponent>
      </Element>
    </div>
  )
}

export default DomesticSearch
